import { createContext } from "react";

export const FirstRenderContext = createContext(true);
